import axios, { AxiosError } from 'axios';
import { loginRequest } from 'B2C';
import { HTTP_STATUS_CODES } from 'Enum/HttpStatusCodes';
import { msalInstance } from 'index';
import { getTokenFromUrl } from 'Utils';

export const api = axios.create({
  baseURL: process.env.REACT_APP_DOMAIN,
});

const notAuthAction = async () => {
  if (
    !window.location.pathname
      .toLowerCase()
      .includes('universalRequest'.toLocaleLowerCase())
  )
    await msalInstance.loginRedirect(loginRequest);
};

let requestsTimeOut: NodeJS.Timeout | null = null;

api.interceptors.request.use(
  async function (config) {
    const token =
      sessionStorage.getItem('B2CToken') ||
      getTokenFromUrl() ||
      sessionStorage.getItem('token');

    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${token}`,
    };
    return config;
  },
  async function (error: AxiosError) {
    if (error.response?.status === HTTP_STATUS_CODES.Forbidden) {
      if (requestsTimeOut !== null) clearTimeout(requestsTimeOut);
      requestsTimeOut = setTimeout(() => {
        alert(error.response!.data.message);
      }, 1000);
    } else if (error.response?.status === HTTP_STATUS_CODES.Unauthorized) {
      notAuthAction();
    } else if (
      error.response?.status === HTTP_STATUS_CODES.InternalServerError
    ) {
      window.location.href = '/error';
    }
    return error;
  }
);

api.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error: any) {
    console.log(error);
    if (error.response?.status === HTTP_STATUS_CODES.Forbidden) {
      if (requestsTimeOut !== null) clearTimeout(requestsTimeOut);
      requestsTimeOut = setTimeout(() => {
        alert(error.response!.data.message);
      }, 1000);
    } else if (
      error.response?.status === HTTP_STATUS_CODES.Unauthorized ||
      error.correlationId
    ) {
      notAuthAction();
    } else if (
      error.response?.status === HTTP_STATUS_CODES.InternalServerError
    ) {
      window.location.href = '/error';
    }
    return error;
  }
);
